<template>
  <div class="dropdown-box-type-1" v-if="data">
    <div class="box" :class="{ 'box-disable': !mode, active: value }">
      <span class="box-title">{{ tempBoxTitle }}</span>
      <span class="title" aria-readonly="true">{{ tempTitle }}</span>
      <div v-if="mode" class="over-button-box" @click.stop="show"></div>
      <ul class="dropdown-box" ref="idDropdown">
        <li
          v-for="(item, key) in tempData"
          v-bind:key="key"
          @click="selectMenu(key)"
          :class="{ 'active-item': value === key }"
        >
          {{ item.title }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import * as types from '../../store/mutation-types'

export default {
  name: 'dropdown-box-type-1',
  props: {
    boxTitle: {
      default: 'Box title',
      type: String
    },
    title: {
      default: 'Child',
      type: String
    },
    data: {
      default: () => ({
        'hash-key': {
          title: 'No title',
          sort: 0
        }
      }),
      type: Object
    },
    mode: {
      default: true,
      type: Boolean
    },
    value: {
      default: '',
      type: String
    }
  },
  data() {
    return {
      tempBoxTitle: '',
      tempTitle: ''
    }
  },
  created() {
    this.tempBoxTitle = this.boxTitle
    this.tempTitle = this.title
    new Promise(resolve => {
      let check = setInterval(() => {
        if (typeof this.data !== 'undefined') {
          resolve(true)
          clearInterval(check)
        }
      }, 500)
    }).then(() => {
      this.selectMenu(this.value)
    })
  },
  computed: {
    tempData() {
      return this.data
    }
  },
  watch: {
    value(value) {
      console.log('watch dropdown:', value)
      if (typeof this.data[value] !== 'undefined') {
        this.tempTitle = value === '' ? this.title : this.data[value].title
        // this.$emit('input', value)
      } else {
        this.tempTitle = this.title
        this.$emit('input', value)
      }
    },
    data() {
      // index 값이 먼저 들어 온경우와, 데이터가 들어온 경우
      if (this.value) {
        this.selectMenu(this.value)
      }
    }
  },
  methods: {
    /**
     * Click the button to display the corresponding child elements.
     * @param event
     */
    show(event) {
      const el = event.target
      const elChild = el.nextElementSibling // Binding child element.
      // el.parentElement.className += ' active'
      if (elChild.className === 'dropdown-box') {
        this.$store.dispatch(types.SET_GLOBAL_DROPDOWNMODE, 'clear')
        elChild.className = 'dropdown-box active'
      } else {
        // el.parentElement.className
        elChild.className = 'dropdown-box'
      }
    },
    selectMenu(key) {
      console.log('select menu:', key)
      if (typeof this.data[key] !== 'undefined' && key !== 'All') {
        this.tempTitle = this.data[key].title
        this.$emit('input', key)
      } else {
        this.tempTitle = this.title
        this.$emit('input', key)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dropdown-box-type-1 {
  // Actions to prevent other stylesheets from affecting.
  position: relative;
  display: inline;
  float: left;
  border: 1px solid #dbdbdb;
  width: 271px;
  /*background-color: rgb(245, 245, 245);*/
  .box {
    &:hover {
      background-color: rgb(23, 33, 251);
      color: #fff;
    }

    position: relative;
    height: 80px;
    width: inherit;
    background-image: url('../../assets/images/down-arrow.svg');
    background-position-y: 49px;
    background-position-x: 235px;
    background-repeat: no-repeat;

    .box-title {
      position: absolute;
      top: 15px;
      left: 20px;
      font-weight: 600;
    }

    .title {
      position: absolute;
      top: 43px;
      left: 20px;
      /*font-weight: 300;*/
    }

    .over-button-box {
      cursor: pointer;
      position: inherit;
      width: inherit;
      height: inherit;
    }

    //noinspection ALL
    .dropdown-box {
      overflow: hidden;
      height: 0;
      z-index: -1;
      position: absolute;
      left: -1px;
      background-color: rgba(255, 255, 255, 1);
      width: inherit;
      z-index: 9999;
      color: #000;
      opacity: 0;
      visibility: hidden;
      padding: 10px 0;
      border: 1px solid #dbdbdb;

      transition-property: width height background-color font-size left top
        transform transform color;
      transition-duration: 0.3s;
      transition-timing-function: ease-in-out;

      li {
        cursor: pointer;
        line-height: 30px;
        padding: 0 0 0 15px;
        position: relative;
        margin: auto;
        width: 87%;
      }

      li:hover {
        background-color: #f5f5f5;
        transition-property: background-color transform transform color;
        transition-duration: 0.3s;
        transition-timing-function: ease-in-out;
        color: #000;
      }

      .active-item {
        color: #000;
        font-weight: 600;
      }
    }

    //noinspection ALL
    .active {
      height: auto;
      z-index: 1000;
      opacity: 1;
      visibility: visible;

      transition-property: width height background-color font-size left top
        transform transform color;
      transition-duration: 0.3s;
      transition-timing-function: ease-in-out;
    }
  }

  .box-disable {
    &:hover {
      background-color: transparent;
      color: #000;
    }

    position: relative;
    height: 80px;
    width: inherit;
    background-image: none;
  }

  .active {
    background-color: #ececec;
    border: 0;
  }
}
</style>
